document
  .querySelectorAll('[data-column-list-controller]')
  .forEach((controller) => {
    const listGroups = controller.querySelectorAll('[data-list-group]');

    listGroups.forEach((group) => {
      const showMoreBtn = group.querySelector(
        '[data-column-list-show-more-activator]',
      );
      const hiddenItems = group.querySelectorAll(
        '[data-truncated-item="true"]',
      );

      if (showMoreBtn && hiddenItems) {
        showMoreBtn.addEventListener('click', (e) => {
          const showingMore = showMoreBtn.dataset.showingMore === 'true';
          showMoreBtn.textContent = !showingMore ? 'Show less' : 'Show more';
          showMoreBtn.dataset.showingMore = String(!showingMore);

          hiddenItems.forEach((itemEl) => {
            const isTruncated = itemEl.dataset.truncatedItem === 'true';
            itemEl.dataset.truncatedItem = String(!isTruncated);
          });
        });
      }
    });
  });
